
import axios from "axios";
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { errManager } from "@/core/config/Tools";

export default defineComponent({
  name: "file",
  props: {
    fileTitle: String,
    createdAt: String,
    fileType: String,
    download: Boolean,
    file: String,
    method: String
  },
  components: {},
  setup(props){
    const loading = ref(false)
    const { t } = useI18n();

    const DownloadFile = (file) => {
            //VUE_APP_API_URL
            loading.value = true
            axios({
                url: props.file,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                loading.value = false
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fURL = document.createElement('a');
                var nameFile = props.fileTitle + "." + props.fileType

                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                document.body.appendChild(fURL);
                //this.$Progress.finish();
                fURL.click();
            }).catch(({response}) => {
              loading.value = false
                errManager(response);
            })
        }

    /*const Download = (file) => {
      alert(file)
    }*/

    return{
      loading,
      DownloadFile,
      t
    }
  }
});
